module.exports = __webpack_public_path__ + "img/icon_order_list_active.67a3a8b7.png";